export default __webpack_public_path__ + "static/char-s-56-en-5ba8a96c05f8bbf4fa942b8bcbb4d3f2.png";